import { render, staticRenderFns } from "./editCourse.vue?vue&type=template&id=a6fc81aa&scoped=true"
import script from "./editCourse.vue?vue&type=script&lang=js"
export * from "./editCourse.vue?vue&type=script&lang=js"
import style0 from "./editCourse.vue?vue&type=style&index=0&id=a6fc81aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc81aa",
  null
  
)

export default component.exports